/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'
import { Flex } from '../../../components/Layout'

import Toggle from './Toggle'

const ToggleSection = ({ title, description, isEnabled, onClick }) => {
  return (
    <Flex
      noFlex
      alignItems='center'
      css={css`
        cursor: pointer;
        padding-right: 8px;

        &:hover .toggle-container {
          background-color: ${colors.ATTENDANCE_GRAY};
        }
      `}
      onClick={onClick}
    >
      <div
        css={css`
          flex: 1;
        `}
      >
        <div
          css={css`
            font-weight: 500;
            font-size: 16px;
            line-height: 16px;
          `}
        >
          {title}
        </div>
        <div
          css={css`
            font-weight: 500;
            font-size: 14px;
            line-height: 120%;
            color: ${colors.ATTENDANCE_GRAY};
            margin-top: 8px;
            padding-right: 16px;
          `}
        >
          {description}
        </div>
      </div>
      <Toggle isEnabled={isEnabled} />
    </Flex>
  )
}

export default ToggleSection
